// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  
.cell-checkbox {
  display: block;
  width: 25px; height: 25px;
  margin: 5px;
}
  `, "",{"version":3,"sources":["webpack://./src/app/components/farmer-building/farmer-building-history.ts"],"names":[],"mappings":";;AAEA;EACE,cAAc;EACd,WAAW,EAAE,YAAY;EACzB,WAAW;AACb","sourcesContent":["\n  \n.cell-checkbox {\n  display: block;\n  width: 25px; height: 25px;\n  margin: 5px;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
